/**
 * Drawer view: thin wrapper over shell drawer. Exposes all refs for auth, chat, notes.
 */

import type { DrawerShellApi, DrawerDOMRefs, DrawerView } from '../core/types';

export function createDrawerView(
  shellDrawer: DrawerShellApi,
  domRefs: DrawerDOMRefs
): DrawerView {
  return {
    setSlideNumber: shellDrawer.setTitle,
    getDrawerElement: shellDrawer.getDrawer,
    getChatPanel: () => domRefs.chatPanel,
    getNotesPanel: () => domRefs.notesPanel,
    getChatAuthLoading: () => domRefs.chatAuthLoading,
    getChatLoginPanel: () => domRefs.chatLoginPanel,
    getChatLoginError: () => domRefs.chatLoginError,
    getChatMessages: () => domRefs.chatMessages,
    getChatInput: () => domRefs.chatInput,
    getChatFormError: () => domRefs.chatFormError,
    getChatSendBtn: () => domRefs.chatSendBtn,
    getChatReplyPreview: () => domRefs.chatReplyPreview,
    getChatReplyPreviewText: () => domRefs.chatReplyPreviewText,
    getChatReplyPreviewCancel: () => domRefs.chatReplyPreviewCancel,
    getChatScrollBottomBtn: () => domRefs.chatScrollBottomBtn,
    getDrawerTabChatBadge: () => domRefs.drawerTabChatBadge,
    getDrawerTabNotesIndicator: () => domRefs.drawerTabNotesIndicator,
    getNotesSigninMsg: () => domRefs.notesSigninMsg,
    getNotesEditorWrap: () => domRefs.notesEditorWrap,
    getNotesTextarea: () => domRefs.notesTextarea,
    getNotesStatus: () => domRefs.notesStatus,
    getNotesStatusText: () => domRefs.notesStatusText,
    getTabSpeaker: () => domRefs.tabSpeaker ?? null,
    getSpeakerNotesWrap: () => domRefs.speakerWrap ?? null,
    getSpeakerNotesBody: () => domRefs.speakerNotesBody ?? null,
    getSpeakerNotesFontDec: () => domRefs.speakerNotesFontDec ?? null,
    getSpeakerNotesFontInc: () => domRefs.speakerNotesFontInc ?? null,
    setTab: shellDrawer.setTab,
    getActiveTab: shellDrawer.getActiveTab
  };
}
